export default __webpack_public_path__ + "static/media/ROX_4738.cc8fe835.jpg";